import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { BuildPriceEntities } from 'client/data/models/build-price';
import { DrawerV2 } from 'site-modules/shared/components/drawer/drawer-v2';
import { CompareGrid } from 'site-modules/build-price/components/compare-models/compare-grid';
import './compare-models.scss';

export function CompareModels({ styleIdList, styleFilter, buttonClassName = null, hasArrow = true, isMobile = false }) {
  const [isModalOpen, toggleModalOpen] = useToggle();

  return (
    <Fragment>
      <Button
        onClick={toggleModalOpen}
        color="link"
        size="lg"
        className={classnames(
          'compare-models-btn text-transform-none text-decoration-none fw-normal p-0 mb-1_5 mb-md-0',
          buttonClassName
        )}
        data-tracking-id="build_price_open_compare_widget"
      >
        Compare models {hasArrow && <i className="text-primary-darker size-10 icon-arrow-right3" aria-hidden />}
      </Button>
      <DrawerV2
        classNames={{
          drawer: 'p-0 p-md-2 p-lg-3',
          drawerContainer: 'compare-models-modal overflow-hidden w-100 h-100 my-0 mx-auto',
          drawerContent: 'h-100',
        }}
        isOpen={isModalOpen}
        toggle={toggleModalOpen}
        data-tracking-parent="step2_compare"
      >
        <div className="compare-header d-flex justify-content-between align-items-center px-0_5 px-md-1 pt-1 mb-0_5">
          <h2 className="heading-4 mb-0">Compare models</h2>
          <Button color="link" size="lg" className="close-btn p-0_25" aria-label="Close" onClick={toggleModalOpen}>
            <i className="icon-cross2 size-16" aria-hidden />
          </Button>
        </div>
        <CompareGrid styleIdList={styleIdList} styleFilter={styleFilter} isMobile={isMobile} />
      </DrawerV2>
    </Fragment>
  );
}

CompareModels.propTypes = {
  styleFilter: BuildPriceEntities.StyleFilter.isRequired,
  styleIdList: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string,
  hasArrow: PropTypes.bool,
  isMobile: PropTypes.bool,
};
